<template>
  <div class="my-1 cart_inner">
    <div v-if="loading" aria-hidden="true" class="placeholder-glow row pt-1">
      <!-- placeholder -->
      <span class="placeholder col-8 ms-2 mb-2"></span>
      <span class="placeholder col-5 ms-2 mb-2"></span>
    </div>
    <template v-else>
      <a :class="{ 'd-none': amount }" :href="link">Как сделать заказ?<br /></a>
      {{ str }}
      <template v-if="amount > 0"><br /><a href="/cart">Перейти к корзине</a></template>
    </template>
  </div>
</template>

<script>
import { plural } from '@/composable/functions';

export default {
  name: 'CartMini',
  props: {
    cart: {
      type: Object,
      default: () => {
        return {};
      },
      required: true,
    },
    link: {
      type: String,
      default: '#',
    },
  },
  data: function () {
    return {
      loading: true,
      //
      amount: 0,
      str: '',
    };
  },
  watch: {
    cart: {
      deep: true,
      // eslint-disable-next-line
      handler(val, oldVal) {
        this.loading = true;

        this.amount = 0;
        if (typeof val === 'object' && Object.keys(val).length) {
          this.amount = Object.values(val).reduce((total, item) => {
            return parseInt(total) + parseInt(item['amount']);
          }, 0);
        }

        this.str = 'В корзине ничего нет.';
        if (this.amount > 0) {
          this.str = plural(
            this.amount,
            `В корзине ${this.amount} товар.`,
            `В корзине ${this.amount} товара.`,
            `В корзине ${this.amount} товаров`
          );
        }

        this.loading = false;
      },
    },
  },
  methods: {
    //
  },
};
</script>
